import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const ExternalLink = ({
  width = 32,
  height = 32,
  className,
  color,
  decorative = false,
  ariaLabel = "External link",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 32 32"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path d="M25.3333 5.33331H18C17.6318 5.33331 17.3333 5.63179 17.3333 5.99998C17.3333 6.36817 17.6318 6.66665 18 6.66665H24.2662L12.9898 17.943C12.7945 18.1383 12.7945 18.4549 12.9898 18.6502L13.2255 18.8859C13.4208 19.0811 13.7373 19.0811 13.9326 18.8859L25.3333 7.48512V14C25.3333 14.3682 25.6318 14.6666 26 14.6666C26.3682 14.6666 26.6667 14.3682 26.6667 14V6.66665C26.6667 5.93027 26.0697 5.33331 25.3333 5.33331ZM22.68 16.6666C22.68 16.2985 22.9785 16 23.3467 16C23.7045 16.0071 23.9929 16.2955 24 16.6533V24C24 26.2091 22.2091 28 20 28H8C5.79086 28 4 26.2091 4 24V12C4 9.79084 5.79086 7.99998 8 7.99998H14.6667C15.0319 8.00707 15.3262 8.30143 15.3333 8.66665C15.3333 9.03484 15.0349 9.33331 14.6667 9.33331H8C6.52724 9.33331 5.33333 10.5272 5.33333 12V24C5.33333 25.4727 6.52724 26.6666 8 26.6666H20.0133C21.4861 26.6666 22.68 25.4727 22.68 24V16.6666Z" />
    </svg>
  );
};
